import { Box, useTheme } from "@mui/material";
import { Container } from "../../layout";
import React from "react";
export const StickyContainer = ({ children, show, }) => {
    const theme = useTheme();
    return (React.createElement(Box, { "aria-hidden": !show, sx: {
            backgroundColor: theme.palette.background.default,
            left: 0,
            mb: 10,
            mt: 0,
            opacity: show ? 1 : 0,
            pb: 1.5,
            position: "fixed",
            pt: 1.5,
            top: 0,
            transform: `translateY(${show ? "0" : "-50%"})`,
            transition: theme.transitions.create(["transform", "opacity"]),
            width: "100%",
            zIndex: 60,
        } },
        React.createElement(Container, { sx: { pt: 0, pb: 0 } }, children)));
};
//# sourceMappingURL=sticky-container.js.map